import React from 'react';

import { initModuleFederation as initMF } from '@ps-int/fedya-versionator/dist/runtime';
import ReactDOM from 'react-dom';

import { PDOKConfig, SharedDependencies } from './types';

export const initModuleFederation = (pdokConfig: PDOKConfig, deps: SharedDependencies) => {
    return initMF({
        mfConfig: {
            name: 'telemost',
            shared: {
                react: {
                    version: deps.react,
                    scope: 'default',
                    lib: () => React,
                    shareConfig: {
                        singleton: true,
                        requiredVersion: deps.react,
                    },
                },
                'react-dom': {
                    version: deps['react-dom'],
                    scope: 'default',
                    lib: () => ReactDOM,
                    shareConfig: {
                        singleton: true,
                        requiredVersion: deps['react-dom'],
                    },
                },
            },
        },
        fedyaConfig: pdokConfig,
        global: window,
        isClient: true,
    });
};
